import CustomerLocationModel from "@/models/crm/CustomerLocationModel";
import CrmServiceCollection from "@/collections/CrmServiceCollection";

export default class CustomerLocationCollection extends CrmServiceCollection {
  model() {
    return CustomerLocationModel;
  }

}
